import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api } from "../services/api";
import { FiKey, FiTrash2 } from "react-icons/fi";
import "../styles/admin.css";

const formInicial = {
  name: "",
  email: "",
  login: "",
  password: "",
};

const senhaInicial = {
  password: "",
  password_confirmation: "",
};

function AdminUserForm() {
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const usuarioEhIted = usuario?.is_admin && usuario?.login === "ited";
  const [form, setForm] = useState(formInicial);
  const [senhaIted, setSenhaIted] = useState(senhaInicial);
  const [senhaUsuario, setSenhaUsuario] = useState(senhaInicial);
  const [usuarioSenhaAtivo, setUsuarioSenhaAtivo] = useState(null);
  const [mostrarSenhaIted, setMostrarSenhaIted] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [carregando, setCarregando] = useState(false);
  const [carregandoUsuarios, setCarregandoUsuarios] = useState(false);
  const [salvandoSenhaIted, setSalvandoSenhaIted] = useState(false);
  const [salvandoSenhaUsuario, setSalvandoSenhaUsuario] = useState(false);

  useEffect(function () {
    if (!usuarioEhIted) return;
    carregarUsuarios();
  }, [usuarioEhIted]);

  if (!usuarioEhIted) {
    return <Navigate to="/admin" replace />;
  }

  async function carregarUsuarios() {
    setCarregandoUsuarios(true);
    try {
      const response = await api.get("/users");
      setUsuarios(response.data || []);
      setErro("");
    } catch (error) {
      console.error("Erro ao carregar usuarios:", error);
      setErro(error.response?.data?.message || "Nao foi possivel carregar os usuarios.");
    } finally {
      setCarregandoUsuarios(false);
    }
  }

  function atualizarCampo(campo, valor) {
    setForm((prev) => ({ ...prev, [campo]: valor }));
  }

  function obterMensagemErro(error, fallback) {
    const errors = error.response?.data?.errors;
    const primeiraMensagem = errors ? Object.values(errors).flat()[0] : null;
    return primeiraMensagem || error.response?.data?.message || fallback;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setErro("");
    setSucesso("");
    setCarregando(true);

    try {
      const response = await api.post("/users", form);
      setUsuarios((prev) => [...prev, response.data].sort((a, b) => a.name.localeCompare(b.name)));
      setSucesso("Usuario criado com sucesso.");
      setForm(formInicial);
      setTimeout(() => setSucesso(""), 4000);
    } catch (error) {
      console.error("Erro ao criar usuario:", error);
      setErro(obterMensagemErro(error, "Erro ao criar usuario."));
    } finally {
      setCarregando(false);
    }
  }

  async function alterarSenhaIted(event) {
    event.preventDefault();
    setErro("");
    setSucesso("");
    setSalvandoSenhaIted(true);

    try {
      await api.put("/users/password", senhaIted);
      setSenhaIted(senhaInicial);
      setSucesso("Senha do ITED alterada com sucesso.");
      setTimeout(() => setSucesso(""), 4000);
    } catch (error) {
      console.error("Erro ao alterar senha do ITED:", error);
      setErro(obterMensagemErro(error, "Erro ao alterar senha do ITED."));
    } finally {
      setSalvandoSenhaIted(false);
    }
  }

  async function alterarSenhaUsuario(event, usuarioSelecionado) {
    event.preventDefault();
    setErro("");
    setSucesso("");
    setSalvandoSenhaUsuario(true);

    try {
      await api.put(`/users/${usuarioSelecionado.id}/password`, senhaUsuario);
      setSenhaUsuario(senhaInicial);
      setUsuarioSenhaAtivo(null);
      setSucesso(`Senha de "${usuarioSelecionado.name}" alterada com sucesso.`);
      setTimeout(() => setSucesso(""), 4000);
    } catch (error) {
      console.error("Erro ao alterar senha do usuario:", error);
      setErro(obterMensagemErro(error, "Erro ao alterar senha do usuario."));
    } finally {
      setSalvandoSenhaUsuario(false);
    }
  }

  function abrirTrocaSenha(usuarioSelecionado) {
    setErro("");
    setSucesso("");
    setSenhaUsuario(senhaInicial);
    setUsuarioSenhaAtivo((idAtual) => (idAtual === usuarioSelecionado.id ? null : usuarioSelecionado.id));
  }

  async function excluirUsuario(usuarioSelecionado) {
    setErro("");
    setSucesso("");

    try {
      await api.delete(`/users/${usuarioSelecionado.id}`);
      setUsuarios((prev) => prev.filter((item) => item.id !== usuarioSelecionado.id));
      setSucesso(`Usuario "${usuarioSelecionado.name}" excluido com sucesso.`);
      setTimeout(() => setSucesso(""), 4000);
    } catch (error) {
      console.error("Erro ao excluir usuario:", error);
      setErro(error.response?.data?.message || "Erro ao excluir usuario.");
    }
  }

  return (
    <div className="admin-container admin-user-create-page">
      <div className="admin-user-create-shell">
        <header className="admin-user-create-header">
          {/* <button type="button" className="btn-voltar" onClick={() => navigate("/admin")}>
            Voltar
          </button> */}
          <div>
            <span className="admin-eyebrow">Acesso ITED</span>
            <h1>Usuarios do painel</h1>
          </div>
        </header>

        <main className="admin-user-create-card">
          <aside className="admin-user-create-aside">
            <span>Permissoes</span>
            <h2>Usuario operacional</h2>
            <p>Este acesso podera criar, editar e excluir cards. A gestao de usuarios continua exclusiva do login ITED.</p>
          </aside>

          <form className="admin-user-create-form" onSubmit={handleSubmit}>
            {sucesso && <div className="notification success">{sucesso}</div>}
            {erro && <div className="notification error">{erro}</div>}

            <div className="admin-user-field-grid">
              <label>
                Nome do usuario
                <input
                  type="text"
                  value={form.name}
                  onChange={(e) => atualizarCampo("name", e.target.value)}
                  placeholder="Ex: Maria Silva"
                  required
                />
              </label>

              <label>
                Email
                <input
                  type="email"
                  value={form.email}
                  onChange={(e) => atualizarCampo("email", e.target.value)}
                  placeholder="usuario@empresa.com"
                />
              </label>

              <label>
                Login
                <input
                  type="text"
                  value={form.login}
                  onChange={(e) => atualizarCampo("login", e.target.value)}
                  placeholder="Ex: maria.silva"
                  required
                />
              </label>

              <label>
                Senha
                <input
                  type="password"
                  value={form.password}
                  onChange={(e) => atualizarCampo("password", e.target.value)}
                  placeholder="Minimo 6 caracteres"
                  minLength="6"
                  required
                />
              </label>
            </div>

            <div className="admin-user-create-actions">
              <button
                type="button"
                className="btn-icon-password"
                aria-label="Alterar propria senha"
                title="Alterar propria senha"
                onClick={() => setMostrarSenhaIted((valorAtual) => !valorAtual)}
              >
                <FiKey />
              </button>

              <div className="admin-user-main-actions">
                <button type="button" className="btn-voltar" onClick={() => navigate("/admin")}>
                  Voltar
                </button>
                <button type="submit" className="admin-primary-action" disabled={carregando}>
                  {carregando ? "Criando..." : "Criar usuario"}
                </button>
              </div>
            </div>
          </form>
        </main>

        {mostrarSenhaIted && (
          <section className="admin-user-password-card">
            <div>
              <span className="admin-eyebrow">Senha ITED</span>
              <h2>Alterar propria senha</h2>
            </div>

            <form className="admin-user-password-form" onSubmit={alterarSenhaIted}>
              <label>
                Nova senha
                <input
                  type="password"
                  value={senhaIted.password}
                  onChange={(e) => setSenhaIted((prev) => ({ ...prev, password: e.target.value }))}
                  placeholder="Minimo 6 caracteres"
                  minLength="6"
                  required
                />
              </label>

              <label>
                Confirmar senha
                <input
                  type="password"
                  value={senhaIted.password_confirmation}
                  onChange={(e) => setSenhaIted((prev) => ({ ...prev, password_confirmation: e.target.value }))}
                  placeholder="Repita a nova senha"
                  minLength="6"
                  required
                />
              </label>

              <button type="submit" className="admin-primary-action" disabled={salvandoSenhaIted}>
                {salvandoSenhaIted ? "Salvando..." : "Salvar senha"}
              </button>
            </form>
          </section>
        )}

        <section className="admin-user-create-list-card">
          <div className="admin-users-header">
            <div>
              <span className="admin-eyebrow">Usuarios</span>
              <h2>Acessos cadastrados</h2>
            </div>
            <span>{usuarios.length} usuario(s)</span>
          </div>

          <div className="admin-users-list">
            {carregandoUsuarios ? (
              <div className="admin-empty-state">Carregando usuarios...</div>
            ) : usuarios.length === 0 ? (
              <div className="admin-empty-state">Nenhum usuario criado ainda.</div>
            ) : (
              usuarios.map((usuarioItem) => (
                <article className="admin-user-row" key={usuarioItem.id}>
                  <div>
                    <strong>{usuarioItem.name}</strong>
                    {usuarioItem.email && <span>{usuarioItem.email}</span>}
                    <small>Login: {usuarioItem.login}</small>
                  </div>
                  <div className="admin-user-row-actions">
                    <button
                      type="button"
                      className="btn-icon-password"
                      aria-label={`Alterar senha de ${usuarioItem.name}`}
                      title="Alterar senha"
                      onClick={() => abrirTrocaSenha(usuarioItem)}
                    >
                      <FiKey />
                    </button>

                    <button
                      type="button"
                      className="btn-icon-delete"
                      aria-label={`Excluir usuario ${usuarioItem.name}`}
                      title="Excluir usuario"
                      onClick={() => {
                        if (window.confirm(`Tem certeza que deseja excluir o usuario "${usuarioItem.name}"?`)) {
                          excluirUsuario(usuarioItem);
                        }
                      }}
                    >
                      <FiTrash2 />
                    </button>
                  </div>

                  {usuarioSenhaAtivo === usuarioItem.id && (
                    <form className="admin-user-inline-password" onSubmit={(event) => alterarSenhaUsuario(event, usuarioItem)}>
                      <label>
                        Nova senha
                        <input
                          type="password"
                          value={senhaUsuario.password}
                          onChange={(e) => setSenhaUsuario((prev) => ({ ...prev, password: e.target.value }))}
                          placeholder="Minimo 6 caracteres"
                          minLength="6"
                          required
                        />
                      </label>

                      <label>
                        Confirmar senha
                        <input
                          type="password"
                          value={senhaUsuario.password_confirmation}
                          onChange={(e) => setSenhaUsuario((prev) => ({ ...prev, password_confirmation: e.target.value }))}
                          placeholder="Repita a senha"
                          minLength="6"
                          required
                        />
                      </label>

                      <button type="submit" className="admin-primary-action" disabled={salvandoSenhaUsuario}>
                        {salvandoSenhaUsuario ? "Salvando..." : "Salvar"}
                      </button>
                    </form>
                  )}
                </article>
              ))
            )}
          </div>
        </section>
      </div>
    </div>
  );
}

export default AdminUserForm;
